import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { useI18n } from "@/context/I18nContext";
import { privacyPolicy } from "@/i18n/legal";

export default function Privacy() {
  const { lang } = useI18n();
  const doc = privacyPolicy[lang] || privacyPolicy.en;

  return (
    <div className="grain min-h-screen bg-background text-foreground">
      <header className="sticky top-0 z-50 border-b border-border/40 bg-background/70 backdrop-blur-2xl">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-2" data-testid="privacy-home-link">
            <BrandMark className="h-9 w-9" />
            <span className="font-serif text-xl font-semibold">EverMind</span>
          </Link>
          <LanguageSwitcher compact testid="privacy-language-switcher" />
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-16" data-testid="privacy-page">
        <Link to="/" className="mb-8 inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground" data-testid="privacy-back-link">
          <ArrowLeft className="h-4 w-4" strokeWidth={1.5} /> {doc.backHome}
        </Link>
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <h1 className="font-serif text-4xl font-semibold tracking-tight sm:text-5xl">{doc.title}</h1>
          <p className="mt-2 text-sm text-muted-foreground">{doc.updated}</p>
          <p className="mt-6 text-lg leading-relaxed text-muted-foreground">{doc.intro}</p>

          <div className="mt-10 space-y-8">
            {doc.sections.map((s, i) => (
              <section key={i} data-testid={`privacy-section-${i}`}>
                <h2 className="font-serif text-xl">{s.h}</h2>
                <p className="mt-2 leading-relaxed text-muted-foreground">{s.b}</p>
              </section>
            ))}
          </div>
        </motion.div>
      </main>

      <footer className="border-t border-border/40 py-8 text-center text-xs text-muted-foreground">
        <Link to="/impressum" className="hover:text-foreground" data-testid="privacy-impressum-link">Impressum</Link>
        <span className="mx-2">·</span>
        <Link to="/support" className="hover:text-foreground" data-testid="privacy-support-link">Support</Link>
        <span className="mx-2">·</span>
        © {new Date().getFullYear()} EverMind
      </footer>
    </div>
  );
}
